import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Select from 'react-select'
import CloseIcon from '../../assets/CloseIcon'
import {
  HEADER_CONFIG,
  HEADER_CONST,
} from '../../common/constant/common-constant'
import {
  ADD_PRODUCT_RECEIVING_FLOW,
  PAGE_CONST,
  PERMISSION_FEATURE,
  PERMISSION_SCREEN,
  PERMISSION_TYPE,
  PRODUCT_DETAIL_FIELDS,
  PRODUCT_STRIP_MEDICAL_CATEGORY,
} from '../../common/constant/page-constant'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import { redirect } from '../../common/utils/redirectionUtils'
import Card from '../Common/Card/Card'
import MobileHeader from '../Common/Header/MobileHeader'

import CheckPrimaryIcon from '../../assets/CheckPrimaryIcon'
import {
  convertToTitleCase,
  formatDate,
  formatTime,
} from '../../common/utils/appUtils'
import { formatProductListLabel } from '../../common/utils/productUtils'
import { addProductReceivingHelper } from '../../helper/home-helper'
import {
  addOrderBookHelper,
  getOrderBookDetailsHelper,
  getOrderBookHelper,
  getOrderBookSearchResultsHelper,
  getOrderBookSearchSuggestionsHelper,
  updateOrderBookStatusHelper,
  updateOrderBookHelper,
} from '../../helper/personal-details-helper'
import {
  addProductReceivingAlertAction,
  newOrderBookAction,
} from '../../modules/actions/action'
import AcknowledgeScreen from '../Common/AcknowledgeScreen/AcknowledgeScreen'
import AddProductReceiving from '../ProductReceiving/AddProductReceiving'
import currencyFormatter from './../../common/utils/currencyFormatterUtils'
import '../Home/Home.scss'
import './OrderBook.scss'
import ViewOrderBook from './ViewOrderBook'

// Order Book Status Constants
const ORDER_BOOK_STATUS = {
  HOLD: 'HOLD',
  CONFIRMED: 'CONFIRMED',
  RECEIVED: 'RECEIVED',
}

const OrderBook = (props) => {
  const navigate = useNavigate()
  const isMobile = useCheckMobileScreen()

  const [viewDrawer, setViewDrawer] = useState(false)
  const [open, setOpen] = useState(false)
  const [headerOptions, setHeaderOptions] = useState({
    [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
    [HEADER_CONFIG.TITLE]: HEADER_CONST.TERMS_AND_CONDITIONS,
    [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => redirect(navigate, PAGE_CONST.HOME),
  })
  const [isAddOrderActive, setIsAddOrderActive] = useState(false)
  const [orderBookData, setOrderBookData] = useState([])
  const [activeTab, setActiveTab] = useState(ORDER_BOOK_STATUS.HOLD)
  const [editingOrderId, setEditingOrderId] = useState(null)
  const [editingOrderData, setEditingOrderData] = useState(null)
  const [searchType, setSearchType] = useState('')
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedSearchTerm, setSelectedSearchTerm] = useState(undefined)
  const [searchSuggestions, setSearchSuggestions] = useState([])
  const [searchResults, setSearchResults] = useState([])
  const [selectedProducts, setSelectedProducts] = useState([])
  const [viewAddedProduct, setViewAddedProduct] = useState(false)
  const [searchResultDataList, setSearchResultDataList] = useState([])
  const [recentSearchDataList, setRecentSearchDataList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [prevSearchTermLength, setPrevSearchTermLength] = useState(0)
  const [timer, setTimer] = useState()
  const [apiCalled, setApiCalled] = useState(false)
  const [orderBookAlert, setOrderBookAlert] = useState(false)
  const [addProductReceivingAlert, setAddProductReceivingAlert] =
    useState(false)
  const [orderDetailsData, setOrderDetailsData] = useState([])
  const [productReceivingData, setProductReceivingData] = useState({})
  const [pROpen, setPROpen] = useState(false)
  const [serverError, setServerError] = useState(undefined)
  const [permissions, setPermissions] = useState({})
  // const inputRef = useRef(null)

  useEffect(() => {
    console.log('in useEffect of order book')
    getOrderBook()
  }, [])

  useEffect(() => {
    let addOrderBookAlert = props.alert?.addOrderBookAlert
    setOrderBookAlert(addOrderBookAlert)
  }, [props.alert?.addOrderBookAlert])

  useEffect(() => {
    let addProductReceivingAlert = props.alert?.addProductReceivingAlert
    setAddProductReceivingAlert(addProductReceivingAlert)
  }, [props.alert?.addProductReceivingAlert])

  useEffect(() => {
    handleSearchSuggestions(searchTerm)
    return () => clearTimeout(timer)
  }, [searchTerm])

  const handleHeaderConfigUpdate = (title, handleBackFunc) => {
    setHeaderOptions({
      [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
      [HEADER_CONFIG.TITLE]: title,
      [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => handleBackFunc(),
    })
  }

  useEffect(() => {
    if (!isAddOrderActive && !viewDrawer && !pROpen) {
      handleHeaderConfigUpdate(HEADER_CONST.ORDER_BOOK, () =>
        props?.onBackClick()
      )
      return
    }

    handleHeaderConfigUpdate(HEADER_CONST.ADD_ORDER_BOOK, () => {
      setIsAddOrderActive(false)
      setViewDrawer(false)
      setPROpen(false)
    })
  }, [isAddOrderActive, viewDrawer, pROpen])

  useEffect(() => {
    if (props.loginData.permissions) {
      let permission = props.loginData.permissions.filter(
        (permission) => permission.screen === PERMISSION_SCREEN.MANAGE_STORE
      )[0]

      if (permission) setPermissions(permission)
    }
  }, [props.loginData])

  const handleDrawerToggle = () => {
    setViewDrawer(!viewDrawer)
    setOpen(!open)
  }

  const getOrderBook = async () => {
    try {
      let data = await getOrderBookHelper()

      setOrderBookData(data)
    } catch (err) {}
  }

  // Filter orders by status - map old statuses to new ones
  const getFilteredOrders = () => {
    if (!orderBookData || orderBookData.length === 0) return []
    
    return orderBookData
      .filter((order) => {
        const status = order?.status?.toUpperCase()
        
        // Map old statuses to new ones
        if (activeTab === ORDER_BOOK_STATUS.HOLD) {
          return status === 'HOLD' || status === 'PENDING'
        } else if (activeTab === ORDER_BOOK_STATUS.CONFIRMED) {
          return status === 'CONFIRMED' || status === 'COMPLETED'
        } else if (activeTab === ORDER_BOOK_STATUS.RECEIVED) {
          return status === 'RECEIVED'
        } else if (activeTab === 'CANCELLED') {
          return status === 'CANCELLED'
        }
        return false
      })
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
  }

  // Get display status (convert old statuses to new display names)
  const getDisplayStatus = (status) => {
    const upperStatus = status?.toUpperCase()
    if (upperStatus === 'PENDING') return 'Hold'
    if (upperStatus === 'COMPLETED') return 'Confirmed'
    return convertToTitleCase(status || '')
  }

  // Get count of orders by status - not used in new UI but kept for reference
  const getStatusCount = (statusType) => {
    if (!orderBookData || orderBookData.length === 0) return 0
    
    return orderBookData.filter((order) => {
      const status = order?.status?.toUpperCase()
      if (statusType === ORDER_BOOK_STATUS.HOLD) {
        return status === 'HOLD' || status === 'PENDING'
      } else if (statusType === ORDER_BOOK_STATUS.CONFIRMED) {
        return status === 'CONFIRMED' || status === 'COMPLETED'
      } else if (statusType === ORDER_BOOK_STATUS.RECEIVED) {
        return status === 'RECEIVED'
      } else if (statusType === 'CANCELLED') {
        return status === 'CANCELLED'
      }
      return false
    }).length
  }

  // Handle card action from 3-dot menu
  const handleCardAction = (action, orderBook) => {
    switch (action) {
      case 'CONFIRM':
        updateOrderBookStatusHelper(orderBook.id, ORDER_BOOK_STATUS.CONFIRMED)
          .then(() => {
            getOrderBook()
          })
          .catch((err) => {
            console.error('Error confirming order:', err)
          })
        break
      case 'EDIT':
        // Get full order details and navigate to edit mode
        handleEditOrder(orderBook.id)
        break
      case 'CANCEL':
        if (window.confirm('Are you sure you want to cancel this order?')) {
          updateOrderBookStatusHelper(orderBook.id, 'CANCELLED')
            .then(() => {
              getOrderBook()
            })
            .catch((err) => {
              console.error('Error cancelling order:', err)
            })
        }
        break
      case 'RECEIVE':
        // Navigate to Product Receiving with order book data
        handleCardClick(orderBook.id)
        break
      default:
        break
    }
  }

  // Handle edit order - fetch order details and switch to edit mode
  const handleEditOrder = async (orderId) => {
    try {
      const orderDetails = await getOrderBookDetailsHelper(orderId)
      if (orderDetails) {
        setEditingOrderId(orderId)
        setEditingOrderData(orderDetails)
        
        // Pre-populate the search results with existing products
        const existingProducts = orderDetails.product_details?.map((pd) => ({
          ...pd.product,
          id: pd.product?.id,
          name: pd.product?.name,
          dose: pd.product?.dose,
          strength: pd.product?.strength,
          size: pd.product?.size,
          category: pd.product?.category,
          cost_per_unit: pd.product?.cost_per_unit,
          rate_per_unit: pd.product?.rate_per_unit,
          medicine_per_strips: pd.product?.medicine_per_strips,
          pack_size: pd.product?.pack_size,
          pharma_company_id: orderDetails.pharma?.id,
          stock: pd.product?.stock || 0,
          // Pre-set quantity and order_pack for editing
          quantity: pd.quantity || 0,
          order_pack: pd.order_pack || 1,
        })) || []
        
        // Set both search results (for display) and selected products (for form submission)
        setSearchResults(existingProducts)
        setSelectedProducts(existingProducts)
        setViewAddedProduct(true) // Show the products in edit mode
        setIsAddOrderActive(true)
      }
    } catch (err) {
      console.error('Error fetching order details for edit:', err)
    }
  }

  const handleSearchSuggestions = (searchTerm) => {
    console.log('searchTerm : ', searchTerm, ' !searchTerm', !searchTerm)
    if (!searchTerm || searchTerm?.length === 0) {
      clearSearchData()
      return
    }

    const fetchSearchResults = async () => {
      console.log('in fetchSearchResults')
      setIsLoading(true)
      try {
        const results = await getOrderBookSearchSuggestionsHelper(
          searchType,
          searchTerm
        )
        // dispatchRecentSearchListAction(searchTerm)
        setSearchSuggestions(results)
      } catch (error) {
        console.error('Error fetching search results:', error)
      }
      setIsLoading(false)
    }

    // Check if search term length changes by more than 2 characters
    if (
      searchTerm?.length > 0 &&
      Math.abs(searchTerm.length - prevSearchTermLength) > 2
    ) {
      clearTimeout(timer)
      setTimer(null)
      // isTimerSet = false
      console.log('hitting api after 2 character change')
      setPrevSearchTermLength(() => searchTerm.length)
      fetchSearchResults()
      // setApiCalled(() => apiCalled)
    } else {
      console.log('in else timer: ', timer)
      if (!timer) {
        let tr = setTimeout(() => {
          if (searchTerm.length > 0) {
            console.log('hitting api after 1 sec')
            setPrevSearchTermLength(searchTerm.length)
            fetchSearchResults()
            // isTimerSet = false
          }
        }, 1000)
        // setApiCalled(true);
        setTimer(tr)
      } else {
        // Clear the existing timer and set a new one
        console.log('clearing timeout and setting a new one')
        clearTimeout(timer)
        let tr = setTimeout(() => {
          if (searchTerm.length > 0) {
            console.log('hitting api after 1 sec')
            setPrevSearchTermLength(searchTerm.length)
            fetchSearchResults()
            // isTimerSet = false
          }
        }, 1000)
        setTimer(tr)
      }
    }
  }

  const handleSearch = async () => {
    setViewAddedProduct(false)
    try {
      let data = await getOrderBookSearchResultsHelper(
        searchType,
        selectedSearchTerm
      )

      setSearchResults(data)
    } catch (err) {}
  }

  const handleProductCheckboxClick = (product, checked) => {
    let selectedProductList = selectedProducts || []

    let index = selectedProductList.findIndex((p) => p.id === product.id)

    if (checked) {
      if (index < 0) selectedProductList.push(product)
    } else {
      if (index > -1) selectedProductList.splice(index, 1)
    }

    setSelectedProducts([...selectedProductList])

    console.log('selectedProductList: ', selectedProductList)
  }

  const handleQuanitityChange = (product, quantity) => {
    let selectedProductList = selectedProducts || []
    let index = selectedProductList.findIndex((p) => p.id === product.id)

    if (index > -1) {
      product = selectedProductList[index]
      product.quantity = parseInt(quantity) || 0

      selectedProductList[index] = product
      setSelectedProducts([...selectedProductList])
    }
  }

  const handleOrderPackChange = (product, orderPack) => {
    let selectedProductList = selectedProducts || []
    let index = selectedProductList.findIndex((p) => p.id === product.id)

    if (index > -1) {
      product = selectedProductList[index]
      product.order_pack = parseInt(orderPack) || 0
      // Auto calculate order quantity = pack_size * order_pack
      const packSize = product.pack_size || 1
      product.quantity = packSize * product.order_pack

      selectedProductList[index] = product
      setSelectedProducts([...selectedProductList])
    }
  }

  // Format date and quantity display
  const formatDateAndQty = (date, qty) => {
    if (!date) return '-'
    return `${formatDate(date)} / ${qty || 0}`
  }

  // Calculate total cost
  const calculateTotalCost = (product) => {
    const costPerUnit = product?.cost_per_unit || 0
    const quantity = product?.quantity || 0
    return costPerUnit * quantity
  }

  const getSelectedProductTotalAmount = () => {
    let amount = 0

    selectedProducts.map((product) => {
      amount += (product?.cost_per_unit || 0) * product?.quantity
    })

    return amount
  }

  const getSelectedProductTotalQuantity = () => {
    let quantity = 0

    selectedProducts.map((product) => {
      quantity += parseInt(product?.quantity)
    })

    return quantity
  }

  const addOrderBook = async () => {
    if (!viewAddedProduct) {
      setViewAddedProduct(true)
      return
    }

    let supplier_id
    let productDetails = selectedProducts?.map((product) => {
      supplier_id = product?.pharma_company_id

      return {
        id: product?.id,
        quantity: product?.quantity,
        amount: product?.cost_per_unit,
      }
    })
    let reqData = {
      supplier_id: supplier_id,
      product_details: productDetails,
      total_quantity: getSelectedProductTotalQuantity(),
      total_amount: getSelectedProductTotalAmount(),
    }
    
    try {
      // Check if we're editing or creating new
      if (editingOrderId) {
        reqData.order_book_id = editingOrderId
        await updateOrderBookHelper(reqData)
      } else {
        await addOrderBookHelper(reqData)
      }

      props.dispatchNewOrderBookAction(true)
      setTimeout(() => {
        props.dispatchNewOrderBookAction(false)
      }, 5000)

      getOrderBook()
      resetAddOrderForm()
    } catch (err) {
      console.error('Error saving order book:', err)
    }
  }

  // Reset the add/edit order form
  const resetAddOrderForm = () => {
    setSearchResults([])
    setSelectedProducts([])
    setViewAddedProduct(false)
    setIsAddOrderActive(false)
    setEditingOrderId(null)
    setEditingOrderData(null)
    setSearchTerm('')
    setSelectedSearchTerm(undefined)
    setSearchSuggestions([])
  }

  const clearSearchData = () => {
    setSearchSuggestions([])
    setSearchResultDataList([])
    setPrevSearchTermLength(0)
    setApiCalled(() => false)
    clearTimeout(timer)
    setTimer(() => null)
    // setApiCalled(false)
  }

  const handleCardClick = async (id) => {
    try {
      let data = await getOrderBookDetailsHelper(id)

      setOrderDetailsData(data)
      handleDrawerToggle()
    } catch (err) {}
  }

  const handlePRDrawerToggle = () => {
    setPROpen(!setPROpen)
  }

  const convertDataForProductReceiving = (orderBookData) => {
    console.log('orderDetailData: ', orderDetailsData)
    let supplierData = orderDetailsData.pharma
    let productArray = orderDetailsData.product_details?.map((pDetails) => {
      let productObj = {
        ...pDetails.product,
      }

      if (
        PRODUCT_STRIP_MEDICAL_CATEGORY.includes(
          pDetails.product?.[PRODUCT_DETAIL_FIELDS.MEDICAL_CATEGORY]
        )
      ) {
        productObj[PRODUCT_DETAIL_FIELDS.NUMBER_OF_STRIP] = pDetails.quantity
      } else {
        productObj[PRODUCT_DETAIL_FIELDS.QUANTITY] = pDetails.quantity
      }

      return productObj
    })

    let prData = { supplierData, productArray }
    setProductReceivingData(prData)
  }

  const handleConfirmClick = () => {
    setViewDrawer(false)

    // Prepare order book data for Product Receiving
    const supplierData = orderDetailsData.pharma
    const productArray = orderDetailsData.product_details?.map((pDetails) => {
      let productObj = {
        ...pDetails.product,
        ordered_quantity: pDetails.quantity,
        amount: pDetails.amount,
      }

      if (
        PRODUCT_STRIP_MEDICAL_CATEGORY.includes(
          pDetails.product?.[PRODUCT_DETAIL_FIELDS.MEDICAL_CATEGORY]
        )
      ) {
        productObj[PRODUCT_DETAIL_FIELDS.NUMBER_OF_STRIP] = pDetails.quantity
      } else {
        productObj[PRODUCT_DETAIL_FIELDS.QUANTITY] = pDetails.quantity
      }

      return productObj
    })

    // Navigate to Product Receiving Form with order book data
    navigate('/home/productReceiving/new', {
      state: {
        fromOrderBook: true,
        orderBookId: orderDetailsData.id,
        orderNumber: orderDetailsData.order_no,
        supplierData: supplierData,
        productArray: productArray,
        totalQuantity: orderDetailsData.total_quantity,
        totalAmount: orderDetailsData.total_amount,
      }
    })
  }

  // Handle Confirm Order (Hold -> Confirmed)
  const handleConfirmOrder = async () => {
    if (!orderDetailsData?.id) return
    
    updateOrderBookStatusHelper(orderDetailsData.id, ORDER_BOOK_STATUS.CONFIRMED)
      .then(() => {
        setViewDrawer(false)
        getOrderBook()
        props.dispatchNewOrderBookAction(true)
        setTimeout(() => {
          props.dispatchNewOrderBookAction(false)
        }, 3000)
      })
      .catch((err) => {
        console.error('Error confirming order:', err)
      })
  }

  // Handle Cancel Order (Hold -> Cancelled)
  const handleCancelOrder = async () => {
    if (!orderDetailsData?.id) return
    
    if (window.confirm('Are you sure you want to cancel this order?')) {
      updateOrderBookStatusHelper(orderDetailsData.id, 'CANCELLED')
        .then(() => {
          setViewDrawer(false)
          getOrderBook()
        })
        .catch((err) => {
          console.error('Error cancelling order:', err)
        })
    }
  }

  const handlePRSubmit = (data) => {
    data = {
      ...data,
      order_book_id: orderDetailsData.id,
    }

    addProductReceivingHelper(data)
      .then((res) => {
        console.log(res)

        props.addProductReceivingAlertAction(true)
        setTimeout(() => {
          props.addProductReceivingAlertAction(false)
        }, 5000)
        getOrderBook()
        setProductReceivingData({})
        handlePRDrawerToggle()
      })
      .catch((errMsg) => {
        setServerError(errMsg)
      })
  }

  return (
    <>
      {isMobile && <MobileHeader headerOptions={headerOptions} />}
      {addProductReceivingAlert && (
        <AcknowledgeScreen
          icon={<CheckPrimaryIcon />}
          alertType="success"
          alertMessage="New Product Receiving added Successfully!"
          main="New Product Receiving added Successfully!"
          sub="Lorem ipsum dolor sit amet consectetur. Ligula ut volutpat morbi ullamcorper"
        />
      )}
      {orderBookAlert && (
        <AcknowledgeScreen
          icon={<CheckPrimaryIcon />}
          main={'New Order placed Successfully!'}
          sub="Lorem ipsum dolor sit amet consectetur. Ligula ut volutpat morbi ullamcorper"
          success
          alertType="success"
          alertMessage={'New Order placed Successfully!'}
        />
      )}
      <div className="pageBodyRightPanel">
        {!isAddOrderActive && (
          <>
            <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter mb-5">
              <div className="pageBodyRightPanelHeading">Order Book</div>
              {permissions?.features?.[PERMISSION_FEATURE.ORDER_BOOK] ===
                PERMISSION_TYPE.MANAGE && (
                <div className="addProductBtn dFlex aiCenter">
                  <button
                    className="btn btnPrimary"
                    onClick={() => setIsAddOrderActive(true)}
                  >
                    ADD
                  </button>
                </div>
              )}
            </div>
            
            {/* Tab Navigation - Same style as Product Receiving */}
            <div className="orderBookWrapper mt-5">
              <ul className="tabs dFlex">
                <li
                  className={`tabItem ${activeTab === ORDER_BOOK_STATUS.HOLD ? 'active' : ''}`}
                  onClick={() => setActiveTab(ORDER_BOOK_STATUS.HOLD)}
                >
                  Hold
                </li>
                <li
                  className={`tabItem ${activeTab === ORDER_BOOK_STATUS.CONFIRMED ? 'active' : ''}`}
                  onClick={() => setActiveTab(ORDER_BOOK_STATUS.CONFIRMED)}
                >
                  Confirmed
                </li>
                <li
                  className={`tabItem ${activeTab === ORDER_BOOK_STATUS.RECEIVED ? 'active' : ''}`}
                  onClick={() => setActiveTab(ORDER_BOOK_STATUS.RECEIVED)}
                >
                  Received
                </li>
                <li
                  className={`tabItem ${activeTab === 'CANCELLED' ? 'active' : ''}`}
                  onClick={() => setActiveTab('CANCELLED')}
                >
                  Cancelled
                </li>
              </ul>
              <div className="tabContent">
                <div className="tabPane dFlex">
                  {getFilteredOrders()?.length === 0 && (
                    <div className="noDataMessage">No orders found in {activeTab.toLowerCase()} status</div>
                  )}
                  {getFilteredOrders()?.map((orderBook) => {
                    const status = orderBook?.status?.toUpperCase()
                    const isHold = status === 'HOLD' || status === 'PENDING'
                    const isConfirmed = status === 'CONFIRMED' || status === 'COMPLETED'
                    const isReceived = status === 'RECEIVED'
                    const isCancelled = status === 'CANCELLED'
                    const hasManagePermission = permissions?.features?.[PERMISSION_FEATURE.ORDER_BOOK] === PERMISSION_TYPE.MANAGE

                    // Build card actions based on status
                    let cardActions = []
                    if (isHold && hasManagePermission) {
                      cardActions = ['CONFIRM', 'EDIT', 'CANCEL']
                    } else if (isConfirmed && hasManagePermission) {
                      cardActions = ['RECEIVE']
                    }

                    return (
                      <div className="cardWrap" key={orderBook.id}>
                        <Card
                          handleClick={() => handleCardClick(orderBook.id)}
                          cardCrown={getDisplayStatus(orderBook?.status)}
                          primary={isConfirmed}
                          success={isReceived}
                          cardRight={`BDT ${currencyFormatter(orderBook.total_amount || 0)}`}
                          headerSup={formatDate(orderBook?.created_at)}
                          headerMain={orderBook?.order_no}
                          sales={`Supplier: ${orderBook?.pharma_name}`}
                          orderBook={{
                            totalQuantity: orderBook?.total_quantity,
                          }}
                          users={cardActions.length > 0}
                          cardAction={cardActions}
                          onCardAction={(action) => handleCardAction(action, orderBook)}
                        />
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </>
        )}
        {/* <div className='pageBodyRightPanel'> */}
        {isAddOrderActive && (
          <>
            <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter mb-5">
              <div className="pageBodyRightPanelHeading">
                {editingOrderId ? 'Edit Order Book' : 'Add Order Book'}
              </div>
              <div className="addProductBtn dFlex aiCenter">
                {searchResults && searchResults.length > 0 && (
                  <button
                    className="btn btnPrimary"
                    onClick={() => addOrderBook()}
                  >
                    {editingOrderId ? 'SAVE' : viewAddedProduct ? 'HOLD' : 'SAVE'}
                  </button>
                )}
                <div
                  className="pointer ml-4"
                  onClick={() => resetAddOrderForm()}
                >
                  <CloseIcon />
                </div>
              </div>
            </div>
            {/* <div className=""> */}
            <div className="dFlex flexNowrap ai-flex-start">
              <div className="formGroup formFloating fgrow1 maxWidth">
                <Select
                  className="formSelect reactSelect"
                  id="floatingSelect"
                  // value={
                  //     billDetails?.[
                  //     BILL_DETAILS_FIELDS.PHARMA_COMPANY
                  //     ]
                  // }
                  onChange={(option) => {
                    setSearchType(option.name)
                  }}
                  options={[
                    {
                      label: 'Pharma Company',
                      name: 'PHARMA_COMPANY',
                    },
                    {
                      label: 'Product Name',
                      name: 'PRODUCT_NAME',
                    },
                    {
                      label: 'Product Generic Name',
                      name: 'GENERIC_NAME',
                    },
                  ]}
                  getOptionLabel={(option) => option.label}
                  placeholder="Search By"
                  styles={{
                    control: (base) => ({
                      border: 0,
                      display: 'flex',
                      paddingTop: '20px',
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused
                        ? 'rgb(222, 235, 255)'
                        : state.isSelected
                          ? '#FFF'
                          : 'inherit',
                      color: '#212529',
                      '&:hover': {
                        backgroundColor: state.isSelected
                          ? '#DEEBFF'
                          : 'rgb(222, 235, 255)',
                      },
                    }),
                  }}
                  // menuIsOpen={true}
                  // isClearable
                />
                <label for="floatingSelect">Search By</label>
              </div>
              <div className="formGroup formFloating maxWidth fgrow1 ml-4">
                <Select
                  className="formSelect reactSelect"
                  id="floatingSelect"
                  // value={
                  //     billDetails?.[
                  //     BILL_DETAILS_FIELDS.PHARMA_COMPANY
                  //     ]
                  // }
                  onInputChange={
                    (option) => {
                      if (option) setSearchTerm(option)
                    }
                    // handleBillDetailUpdate(
                    //     BILL_DETAILS_FIELDS.PHARMA_COMPANY,
                    //     option
                    // )
                  }
                  onChange={(option) => {
                    setSelectedSearchTerm(option?.value)
                  }}
                  options={searchSuggestions}
                  getOptionLabel={(option) => option.label}
                  placeholder={`Select ${convertToTitleCase(searchType)}`}
                  styles={{
                    control: (base) => ({
                      border: 0,
                      display: 'flex',
                      paddingTop: '20px',
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused
                        ? 'rgb(222, 235, 255)'
                        : state.isSelected
                          ? '#FFF'
                          : 'inherit',
                      color: '#212529',
                      '&:hover': {
                        backgroundColor: state.isSelected
                          ? '#DEEBFF'
                          : 'rgb(222, 235, 255)',
                      },
                    }),
                  }}
                  // menuIsOpen={true}
                  isClearable
                />
                <label for="floatingSelect">
                  {`Select ${convertToTitleCase(searchType)}`}
                </label>
              </div>

              <div className="addProductBtn dFlex aiCenter ml-4">
                <button
                  className="btn btnPrimary height"
                  onClick={() => handleSearch()}
                >
                  Search
                </button>
              </div>
            </div>
            {/* <div className="formGroup formFloating fgrow1 relative">
                            <input
                                className="autocomplete-input formControl"
                                placeholder="Search by Product Name OR Generic Name"
                                type="text"
                                id="location"
                            />
                            <label for="location">
                                Search by Product Name OR Generic Name
                            </label>
                        </div> */}
            {!viewAddedProduct && (
              <div className="mb-5">
                {searchResults && searchResults.length > 0 && (
                  <div className="tableResponsive">
                    <table className="orderBook orderBookEnhanced">
                      <thead>
                        <tr>
                          <td width="3%">S/N</td>
                          <td width="3%"></td>
                          <td>Product Name</td>
                          <td>Category</td>
                          <td className="nowrap">TP/Unit</td>
                          <td className="nowrap">VAT/Unit</td>
                          <td className="nowrap">Cost/Unit</td>
                          <td className="nowrap">Rate/Unit</td>
                          <td>Stock</td>
                          <td>Med/Strip</td>
                          <td>Pack Size</td>
                          <td width="7%">Order Pack</td>
                          <td width="7%">Order Qty</td>
                          <td>Last Purchase Date & Qty</td>
                          <td>Last Sell Date & Qty</td>
                          <td className="nowrap">Total Cost</td>
                        </tr>
                      </thead>
                      <tbody>
                        {searchResults.map((searchResult, index) => {
                          const selectedProduct = selectedProducts.find(
                            (product) => product.id === searchResult.id
                          )
                          const isSelected = !!selectedProduct
                          const tpPerUnit = searchResult.tp_per_unit || 0
                          const vatPerUnit = searchResult.vat_per_unit || 0
                          const costPerUnit = searchResult.cost_per_unit || (tpPerUnit + vatPerUnit)
                          const orderQty = selectedProduct?.quantity || 0
                          const totalCost = costPerUnit * orderQty

                          return (
                            <tr key={searchResult.id}>
                              <td>{index + 1}</td>
                              <td>
                                <div className="formCheck">
                                  <input
                                    className="formCheckInput"
                                    type="checkbox"
                                    name="flexRadioDefault"
                                    disabled={
                                      selectedProducts?.length > 0 &&
                                      selectedProducts?.[0]?.pharma_company !==
                                        searchResult?.pharma_company
                                    }
                                    checked={isSelected}
                                    id=""
                                    onChange={(event) => {
                                      handleProductCheckboxClick(
                                        searchResult,
                                        event.target.checked
                                      )
                                    }}
                                  />
                                </div>
                              </td>
                              <td>{formatProductListLabel(searchResult, { includeCategory: false })}</td>
                              <td>{searchResult.category}</td>
                              <td className="nowrap">
                                {tpPerUnit ? `BDT ${tpPerUnit}` : '-'}
                              </td>
                              <td className="nowrap">
                                {vatPerUnit ? `BDT ${vatPerUnit}` : '-'}
                              </td>
                              <td className="nowrap">
                                {costPerUnit ? `BDT ${costPerUnit}` : '-'}
                              </td>
                              <td className="nowrap">
                                {searchResult.rate_per_unit
                                  ? `BDT ${searchResult.rate_per_unit}`
                                  : '-'}
                              </td>
                              <td>{searchResult.stock || 0}</td>
                              <td>{searchResult.medicine_per_strips || '-'}</td>
                              <td>{searchResult.pack_size || '-'}</td>
                              <td>
                                <div className="formGroup mb-0">
                                  {isSelected ? (
                                    <input
                                      className="formControl formsm"
                                      placeholder="Pack"
                                      type="number"
                                      min="0"
                                      value={selectedProduct?.order_pack || ''}
                                      onChange={(event) =>
                                        handleOrderPackChange(
                                          searchResult,
                                          event.target.value
                                        )
                                      }
                                    />
                                  ) : (
                                    ''
                                  )}
                                </div>
                              </td>
                              <td>
                                <div className="formGroup mb-0">
                                  {isSelected ? (
                                    <input
                                      className="formControl formsm"
                                      placeholder="Qty"
                                      type="number"
                                      min="0"
                                      value={orderQty}
                                      onChange={(event) =>
                                        handleQuanitityChange(
                                          searchResult,
                                          event.target.value
                                        )
                                      }
                                    />
                                  ) : (
                                    ''
                                  )}
                                </div>
                              </td>
                              <td className="nowrap">
                                {formatDateAndQty(
                                  searchResult.last_purchase_date,
                                  searchResult.last_purchase_qty
                                )}
                              </td>
                              <td className="nowrap">
                                {formatDateAndQty(
                                  searchResult.last_sell_date,
                                  searchResult.last_sell_qty
                                )}
                              </td>
                              <td className="nowrap">
                                {isSelected && totalCost > 0
                                  ? `BDT ${currencyFormatter(totalCost)}`
                                  : '-'}
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
          </>
        )}
        {viewAddedProduct && (
          <div className="mb-5">
            <div className="tableResponsive">
              <table className="orderBook orderBookEnhanced">
                <thead>
                  <tr>
                    <td width="3%">S/N</td>
                    <td>Product Name</td>
                    <td>Category</td>
                    <td className="nowrap">TP/Unit</td>
                    <td className="nowrap">VAT/Unit</td>
                    <td className="nowrap">Cost/Unit</td>
                    <td>Pack Size</td>
                    <td className="alignright">Order Pack</td>
                    <td className="alignright">Qty</td>
                    <td width="15%" className="alignright">Total Cost</td>
                  </tr>
                </thead>
                <tbody>
                  {selectedProducts?.map((product, index) => {
                    const tpPerUnit = product?.tp_per_unit || 0
                    const vatPerUnit = product?.vat_per_unit || 0
                    const costPerUnit = product?.cost_per_unit || (tpPerUnit + vatPerUnit)
                    const totalCost = costPerUnit * (product?.quantity || 0)

                    return (
                      <tr key={product?.id}>
                        <td>{index + 1}</td>
                        <td>{formatProductListLabel(product, { includeCategory: false })}</td>
                        <td>{product?.category || '-'}</td>
                        <td className="nowrap">
                          {tpPerUnit ? `BDT ${tpPerUnit}` : '-'}
                        </td>
                        <td className="nowrap">
                          {vatPerUnit ? `BDT ${vatPerUnit}` : '-'}
                        </td>
                        <td className="nowrap">
                          {costPerUnit ? `BDT ${costPerUnit}` : '-'}
                        </td>
                        <td>{product?.pack_size || '-'}</td>
                        <td className="alignright">{product?.order_pack || '-'}</td>
                        <td className="alignright">{product?.quantity || 0}</td>
                        <td className="nowrap alignright">
                          {totalCost > 0
                            ? `BDT ${currencyFormatter(totalCost)}`
                            : '-'}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan={8}>Total</td>
                    <td className="alignright strong">
                      {getSelectedProductTotalQuantity()}
                    </td>
                    <td className="alignright strong">
                      BDT {currencyFormatter(getSelectedProductTotalAmount())}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        )}
      </div>
      <ViewOrderBook
        handleDrawerToggle={() => setViewDrawer(!viewDrawer)}
        open={viewDrawer}
        drawerButton={
          permissions?.features?.[PERMISSION_FEATURE.ORDER_BOOK] ===
          PERMISSION_TYPE.MANAGE
        }
        data={orderDetailsData}
        onConfirmClick={() => handleConfirmClick()}
        onConfirmOrder={() => handleConfirmOrder()}
        onCancelOrder={() => handleCancelOrder()}
      />
      {pROpen && (
        <AddProductReceiving
          open={pROpen}
          handleDrawerToggle={handlePRDrawerToggle}
          handleSubmit={handlePRSubmit}
          flow={ADD_PRODUCT_RECEIVING_FLOW.ORDER_BOOK}
          defaultData={productReceivingData}
          serverError={serverError}
        />
      )}
      {/* </div> */}
      {/* </div> */}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    alert: state.alertReducer.alert,
    loginData: state.loginDataReducer?.loginData,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchNewOrderBookAction: (payload) =>
      dispatch(newOrderBookAction(payload)),
    addProductReceivingAlertAction: (payload) =>
      dispatch(addProductReceivingAlertAction(payload)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderBook)
